import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import Img from "gatsby-image"

import "../section/section.css"
import "./image-text.css"

const ImageText = ({ buttonLink, buttonText, content, image, order = 'standard', subtitle, theme, title }) => (
  <section className={`sec-Section sec-Section-${theme}`}>
    <div className="sec-Section_Inner lyt-Container">
      <div className="sec-Section_Body">
        <div className={`sec-ImageText sec-ImageText-${order}`}>
          <div className="sec-ImageText_ImageContainer">
            {image && (
              <div className="sec-ImageText_Image">
                <Img fluid={image} />
              </div>
            )}
          </div>

          <div className="sec-ImageText_Content">
            {subtitle && (
              <h3 className="sec-Section_SubTitle">
                {subtitle}
              </h3>
            )}

            {title && (
              <h2 className="sec-Section_Title">
                {title}
              </h2>
            )}

            <div className="sec-ImageText_Text" dangerouslySetInnerHTML={{ __html: content }}></div>

            {buttonLink && buttonText && (
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to={buttonLink}
                className="sec-ImageText_Button btn-Primary btn-Primary-yellow">
                {buttonText}
              </AniLink>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default ImageText
